import { Button } from "@/components/ui/button";
import heroImage from "@/assets/santiago-snow-mountains.webp";

export const HeroSection = () => {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    formElement?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img 
          src={heroImage} 
          alt="Vista panorámica de Santiago de Chile con montañas nevadas" 
          className="w-full h-full object-cover"
        />
        {/* Gradiente suave lateral para legibilidad sin ocultar la foto */}
        <div className="absolute inset-0 bg-gradient-to-r from-[hsl(210,60%,10%)]/80 via-[hsl(210,60%,10%)]/50 to-transparent"></div>
      </div>
      
      <div className="relative container mx-auto px-4 text-white max-w-5xl py-40 md:py-48">
        <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight text-left max-w-3xl !text-white">
          Invierte en tu futuro con{" "}
          <span className="text-secondary">REA Managers</span>
        </h1>
        
        <p className="text-lg md:text-xl mb-10 max-w-xl leading-relaxed text-left text-white/[0.92]" style={{ lineHeight: 1.6 }}>
          Departamentos nuevos en ubicaciones estratégicas para inversionistas que buscan fortalecer su patrimonio
        </p>
        
        <Button 
          variant="hero" 
          size="lg" 
          onClick={scrollToForm}
          className="text-base px-8 py-3 h-auto"
        >
          Cotiza aquí
        </Button>
      </div>
    </section>
  );
};
